document.addEventListener("DOMContentLoaded", function () {
  const parentButtons = document.querySelectorAll(".main-parent-link")

  parentButtons.forEach((button) => {
    button.setAttribute("aria-expanded", "false")
    button.addEventListener("click", function () {
      const wrapper = this.nextElementSibling
      const arrow = this.querySelector(".main-nav-arrow-icon")

      // Toggle current menu state
      const isExpanded = this.classList.toggle("active")
      this.setAttribute("aria-expanded", isExpanded)
      wrapper.classList.toggle("is-open")
      arrow?.classList.toggle("rotate")

      // Automatically open all grandchild links inside this wrapper
      wrapper.querySelectorAll(".grandchild-links").forEach((grandchild) => {
        grandchild.classList.add("is-open")
      })
    })
  })

  // Hamburger click
  const drawerToggle = document.getElementById("Navigation-drawer-button-header")
  const drawerContainer = document.getElementById("Navigation-drawer-header")

  drawerToggle.setAttribute("aria-expanded", "false")
  drawerToggle.addEventListener("click", function () {
    const isOpen = drawerContainer.classList.contains("is-open")

    // Toggle drawer open class
    drawerContainer.classList.toggle("is-open")
    drawerToggle.setAttribute("aria-expanded", !isOpen)

    // Toggle icon visibility
    drawerToggle.classList.toggle("is-active", !isOpen)
    // Calculate height of announcement bar and header
    const announcementBar = document.querySelector(".section-announcement-bar")
    const header = document.querySelector(".section-header")

    // Calculate their total height
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0
    const headerHeight = header ? header.offsetHeight : 0
    const totalHeight = announcementHeight + headerHeight

    document.documentElement.style.setProperty("--header-total-height", totalHeight + "px")

    // Assign the total height to another div (create one for demo)
    const targetDiv = document.querySelector(".drawer__content")
    if (targetDiv) {
      targetDiv.style.top = totalHeight + "px"
    }
  })

  /* country selector */

  const disclosureButtons = document.querySelectorAll(".disclosure__button")

  disclosureButtons.forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.stopPropagation() // Prevent triggering document click
      const dropdown = button.nextElementSibling
      if (dropdown && dropdown.classList.contains("localization-dropdown")) {
        const isExpanded = button.getAttribute("aria-expanded") === "true"

        // Close all other dropdowns
        document.querySelectorAll(".localization-dropdown").forEach((d) => {
          d.style.display = "none"
        })
        document.querySelectorAll(".disclosure__button").forEach((b) => {
          b.setAttribute("aria-expanded", "false")
        })

        // Toggle current one
        if (!isExpanded) {
          dropdown.style.display = "block"
          button.setAttribute("aria-expanded", "true")
        }
      }
    })
  })

  // Hide dropdown when clicking outside
  document.addEventListener("click", function (event) {
    document.querySelectorAll(".localization-dropdown").forEach((dropdown) => {
      dropdown.style.display = "none"
    })
    document.querySelectorAll(".disclosure__button").forEach((button) => {
      button.setAttribute("aria-expanded", "false")
    })
  })

  // product page - size, embroidery placement and no of pets variant selection
  const addToCartButton = document.querySelector(".add-to-cart-form-wrapper")
  const addToCartButtonText = addToCartButton?.querySelector("span.add-to-cart-span")
  const variantIdInput = document.querySelector(".product-variant-id")

  const sizeInputs = document.querySelectorAll('.product--variant-size input[type="radio"]')
  const placementRadios = document.querySelectorAll(
    '.product--variant-embroidery-placement input[type="radio"]'
  )
  const petRadios = document.querySelectorAll(
    '.product--variant-number-of-pets input[type="radio"]'
  )

  const sizeLabel = document.querySelector(".product--variant-size [data-selected-value]")
  const placementLabel = document.querySelector(
    ".product--variant-embroidery-placement [data-selected-value]"
  )
  const petLabel = document.querySelector(".product--variant-number-of-pets [data-selected-value]")

  const allVariantsElement = document.querySelector("[data-all-variants]")
  const allVariants = allVariantsElement ? JSON.parse(allVariantsElement.textContent) : []

  // Identify which variant groups are present
  const hasSize = sizeInputs.length > 0
  const hasPlacement = placementRadios.length > 0
  const hasPets = petRadios.length > 0

  // Check if Back in Stock wrapper exists
  const backInStockWrapper = document.querySelector(".onload-back-in-stock_wrapper.BIS_wrapper")

  function getDefaultButtonText() {
    if (hasSize) return "Select Size"
    if (hasPlacement) return "Select Embroidery Placement"
    if (hasPets) return "Select Number of Pets"
    return "Add to cart"
  }

  function initializeRadios(radios, label) {
    radios.forEach((radio) => {
      radio.checked = false
    })
    if (label) label.textContent = ""
  }

  if (addToCartButton) {
    addToCartButton.disabled = true
    addToCartButton.classList.add("disabled")
    const backInStockWrapper = document.querySelector(".onload-back-in-stock_wrapper.BIS_wrapper")
    if (!hasSize && !hasPlacement && !hasPets && backInStockWrapper) {
      addToCartButtonText.textContent = "Sold Out - Notify me when back in stock"
      addToCartButton.disabled = false
      addToCartButton.classList.remove("disabled")
      addToCartButton.addEventListener("click", function (e) {
        const buttonText = addToCartButtonText.textContent?.trim()
        if (buttonText === "Sold Out - Notify me when back in stock") {
          e.preventDefault()
          const emailInput = document.getElementById("onload-notify_email")
          if (!emailInput) {
            alert("Email input not found.")
            return
          }
          if (!emailInput.checkValidity()) {
            emailInput.reportValidity()
            return
          }
        }
      })
    } else {
      addToCartButtonText.textContent = getDefaultButtonText()
    }

    // Only allow enabling the button if size exists
    if (hasSize) {
      addToCartButton.classList.remove("disabled")
      addToCartButton.disabled = true
    }
  }

  // Reset all radio groups
  initializeRadios(sizeInputs, sizeLabel)
  initializeRadios(placementRadios, placementLabel)
  initializeRadios(petRadios, petLabel)

  function isGroupSelected(inputs) {
    return [...inputs].some((input) => input.checked)
  }

  function enableAddToCartIfAllSelected() {
    const sizeOK = !hasSize || isGroupSelected(sizeInputs)
    const placementOK = !hasPlacement || isGroupSelected(placementRadios)
    const petsOK = !hasPets || isGroupSelected(petRadios)

    if (sizeOK && placementOK && petsOK) {
      addToCartButton.disabled = false
      addToCartButton.classList.remove("disabled")
      if (addToCartButtonText) addToCartButtonText.textContent = "Add to cart"
    }
  }

  function attachChangeHandler(inputs, label, isSize = false) {
    inputs.forEach((input) => {
      input.addEventListener("change", function () {
        if (input.checked) {
          if (label) label.textContent = input.value

          if (isSize && allVariants.length > 0) {
            const matchedVariant = allVariants.find((variant) => variant.option2 === input.value)
            if (matchedVariant && variantIdInput) {
              variantIdInput.value = matchedVariant.id

              if (!matchedVariant.available) {
                // Sold out → show BIS text
                addToCartButton.disabled = false
                addToCartButton.classList.remove("disabled")
                if (addToCartButtonText) {
                  addToCartButtonText.textContent = "Sold Out - Notify me when back in stock"
                }
                return
              }
            }
          }

          enableAddToCartIfAllSelected()
        }
      })
    })
  }

  // Attach event listeners
  if (hasSize) attachChangeHandler(sizeInputs, sizeLabel, true)
  if (hasPlacement) attachChangeHandler(placementRadios, placementLabel)
  if (hasPets) attachChangeHandler(petRadios, petLabel)

  if (!hasSize && !hasPlacement && !hasPets) {
    if (addToCartButton && !backInStockWrapper) {
      addToCartButton.disabled = false
      addToCartButton.classList.remove("disabled")
    }
  }

  /* Search Customization */
  function findRedirect(searchTerm) {
    const matches = window.searchRedirects.filter((redirect) => {
      if (redirect.matchType === "exact") {
        return searchTerm.toLowerCase() === redirect.searchTerm.toLowerCase()
      } else {
        return searchTerm.toLowerCase().includes(redirect.searchTerm.toLowerCase())
      }
    })
    return matches.sort((a, b) => (b.priority || 1) - (a.priority || 1))[0]
  }

  document.querySelectorAll('form[action="/search"]').forEach((form) => {
    form.addEventListener("submit", function (event) {
      const searchInput = form.querySelector('input[name="q"]')
      if (!searchInput) return

      const searchTerm = searchInput.value.trim()
      const redirect = findRedirect(searchTerm)

      if (redirect) {
        event.preventDefault()
        window.location.href = redirect.redirectUrl
      }
    })
  })

  if (window.location.pathname === "/search") {
    const params = new URLSearchParams(window.location.search)
    const query = params.get("q")
    if (query) {
      const redirect = findRedirect(query)
      if (redirect) {
        window.location.href = redirect.redirectUrl
      }
    }
  }
})
